// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C2vA","questions":"styles_questions__3Ca1r","footer":"styles_footer__qzPxG"};